import React, { useState } from "react";
import Loading from "../../shared/Loading";

const ProductImage = ({ img, className }) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {!loading && (
        <div className={`w-full h-full absolute bg-[#222] flex justify-center items-center`}>
          <Loading />
        </div>
      )}
      <img
        src={`https://api.myunibest.ir/${img.image}`}
        className={`${!loading && "hidden"}`}
        alt=""
        onLoad={() => setLoading(true)}
      />
    </>
  );
};

export default ProductImage;
